<template>
  <div>
    <b-card>
      <!-- contract -->
      <b-form-group :label="$t('Roles')" label-for="contract">
        <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="roles"
            v-model="role"
            :placeholder="$t('Roles')"
            :clearable="true"
            :getOptionLabel="val => val.name"
            class="w-100"
            @input="getRolePrivileges"
            :reduce="val => val.name"
        />

        <b-form-invalid-feedback v-if="errors && ('role' in errors)"
                                 :state="errors && ('role' in errors) ? false : null">
          {{ errors.role[0] }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-card>

    <b-card>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <b-row>
        <b-col cols="12">
          <!-- Action Buttons -->
          <b-button
              :disabled="!role"
              type="submit"
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1 mb-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="submitPrivileges"
          >
            {{ $t('Save Changes')}}
          </b-button>
        </b-col>
      </b-row>

      <b-table ref="refPrivilegesTable" class="position-relative mt-1"
          :items="privileges" responsive selectable select-mode="single"
          :fields="tableColumns" primary-key="id"
          show-empty empty-text="No matching records found">

        <template #head(action)="data">
          <b-form-checkbox  @change="selectAll($event)" />
        </template>

        <template #cell(name)="data">
          {{ data.item }}
        </template>

        <template #cell()="data">
          <b-form-checkbox :checked="requestPrivileges.includes(data.item)"  @change="change(data.item, $event)" />
        </template>

      </b-table>
    </b-card>

  </div>

</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton, BFormGroup, BTable, BFormCheckbox,
  BCol, BRow
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import { OrbitSpinner } from 'epic-spinners'
import MapTab from '@/views/modules/geofence/geofence-create/MapTab'
import rolesModule from '@/views/modules/roles/rolesModule'
import usePermissions from '@/views/modules/permissions/usePermissions'
import vSelect from 'vue-select'

export default {
  components: {
    BTab,BFormGroup, BCol, BRow,
    BTabs,BTable,BFormCheckbox,
    BCard,
    BButton,
    BAlert,
    OrbitSpinner,
    vSelect,
    MapTab,
    BLink,

  },

  setup(props, ctx) {

    const ROLE_S = 'roles'
    if (!store.hasModule(ROLE_S))
        store.registerModule(ROLE_S, rolesModule)

    onUnmounted(() => {
      if (store.hasModule(ROLE_S))
        store.unregisterModule(ROLE_S)
    })

    const { roles, role, errors, requestStatus, privileges, submitPrivileges,
      tableColumns, getRolePrivileges, requestPrivileges, change, selectAll } = usePermissions(ctx)


    return {
      change, selectAll, submitPrivileges,
      requestPrivileges,
      getRolePrivileges,
      tableColumns,
      privileges,
      requestStatus,
      errors,
      roles,
      role
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
